"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var extend_1 = __importDefault(require("extend"));
var TrackerUtil_1 = __importDefault(require("./TrackerUtil"));
var BasicTrackerAbstractImpl_1 = __importDefault(require("./BasicTrackerAbstractImpl"));
;
// TODO Move this to index.ts? Would that wipe out the other definition?
var GoogleAnalytics = /** @class */ (function (_super) {
    __extends(GoogleAnalytics, _super);
    function GoogleAnalytics(options) {
        var _this = _super.call(this, options) || this;
        _this.platformName = GoogleAnalytics.platformName;
        _this.isHitInterceptorSetup = false;
        // Setup
        _this.setupHitInterceptor(); // Used primarily for mirroring stray hits to other trackers, we always set it up.
        // Log information
        _this.getLogger().debug("GoogleAnalytics instance initialized.", "Options: ", options);
        return _this;
    }
    /**
     * @public
     * Returns an instance of this class for the `options.trackerName`. Name is typically
     * not specified and will return the standard image. Name is only used when multiple
     * instances of Google Anlaytics is installed on a website or app.
     * If an instance of this class already exists for a `name` that instance will be reutrned
     * and the other options of the property passed will be ignored.
     */
    GoogleAnalytics.getInstance = function (options) {
        options = extend_1.default(true, {}, GoogleAnalytics.defaultOptions, options);
        if (GoogleAnalytics.instances === undefined) {
            GoogleAnalytics.instances = new Map();
        }
        var tracker = TrackerUtil_1.default.getInstance(options, GoogleAnalytics.instances, function (options) {
            return new GoogleAnalytics(options);
        });
        return tracker;
    };
    /**
     * @public
     */
    GoogleAnalytics.prototype.trackPageview = function (pagePath, title) {
        pagePath = TrackerUtil_1.default.pagePathCleanup(pagePath);
        var fieldsObject = this.buildBaseFieldsObject("pageview");
        fieldsObject.page = pagePath;
        if (title !== undefined && title !== undefined) {
            fieldsObject.title = title;
        }
        this.getPlatformInstance()("send", fieldsObject);
        // Log
        this.getLogger().debug("GoogleAnalytics.trackPageview:", fieldsObject);
    };
    /**
     * @public
     */
    GoogleAnalytics.prototype.trackEvent = function (category, action, label, value, nonInteraction) {
        var fieldsObject = this.buildBaseFieldsObject("event");
        fieldsObject.eventCategory = category;
        fieldsObject.eventAction = TrackerUtil_1.default.eventActionToString(action);
        if (label !== undefined && label !== null) {
            fieldsObject.eventLabel = TrackerUtil_1.default.eventLabelToString(label);
        }
        if (value !== undefined && value !== null) {
            fieldsObject.eventValue = value;
        }
        if (nonInteraction !== undefined && nonInteraction !== null) {
            fieldsObject.nonInteraction = nonInteraction;
        }
        this.getPlatformInstance()("send", fieldsObject);
        // Log
        this.getLogger().debug("GoogleAnalytics.trackEvent:", fieldsObject);
    };
    /**
     * @private
     */
    GoogleAnalytics.prototype.buildBaseFieldsObject = function (hitType) {
        var fieldsObject = {
            plaudit_hitOrigin: "internal",
            hitType: hitType
        };
        var trackerName = this.getTrackerName();
        if (trackerName !== null) {
            fieldsObject.name = trackerName;
        }
        return fieldsObject;
    };
    /**
     * @public
     * Add a tracker which will have its trackPageview() and trackEvent() called
     * when a stray hit happens to the Google Analytics instance this class is backed by.
     * By default it does not include pageviews or events that were reported by calling
     * the same two methods on this class. In other words, it only reports the "stray"
     * hits which we may not know where they came from (e.g. some JS code reports a hit
     * directly to Google Analytics instead of calling a method on this class).
     *
     * A tracker can only be added once. This method will update what is reported to the
     * tracker if the tracker has already been added. If you want to remove the tracker
     * from mirroring all hit types, use removeTrackerToMirrorStrayHits() since additional
     * hit types may be mirrored in the future.
     */
    GoogleAnalytics.prototype.addTrackerToMirrorStrayHits = function (tracker, options) {
        if (options === void 0) { options = {
            pageviews: true,
            events: true
        }; }
        if (tracker === this) {
            // Can't add self to self.
            return;
        }
        if (this.trackersToMirrorStrayHits === undefined) {
            this.trackersToMirrorStrayHits = {
                pageviews: new Set(),
                events: new Set()
            };
        }
        // Pageviews
        if (TrackerUtil_1.default.isBasicPageviewTracker(tracker)) {
            var basicPageviewTracker = tracker;
            if (options.pageviews === true) {
                this.trackersToMirrorStrayHits.pageviews.add(basicPageviewTracker);
            }
            else {
                this.trackersToMirrorStrayHits.pageviews.delete(basicPageviewTracker);
            }
        }
        // Events
        if (TrackerUtil_1.default.isBasicEventTracker(tracker)) {
            var basicEventTracker = tracker;
            if (options.events === true) {
                this.trackersToMirrorStrayHits.events.add(basicEventTracker);
            }
            else {
                this.trackersToMirrorStrayHits.events.delete(basicEventTracker);
            }
        }
    };
    /**
     * @public
     */
    GoogleAnalytics.prototype.removeTrackerToMirrorStrayHits = function (tracker) {
        if (this.trackersToMirrorStrayHits === undefined) {
            return;
        }
        if (TrackerUtil_1.default.isBasicPageviewTracker(tracker)) {
            this.trackersToMirrorStrayHits.pageviews.delete(tracker);
        }
        if (TrackerUtil_1.default.isBasicEventTracker(tracker)) {
            this.trackersToMirrorStrayHits.events.delete(tracker);
        }
    };
    /**
     * @private
     */
    GoogleAnalytics.prototype.setupHitInterceptor = function () {
        var _this = this;
        if (this.isHitInterceptorSetup === true) {
            return;
        }
        // Get the tracker
        var ga = this.getPlatformInstance();
        ga(function (tracker) {
            var trackerName = _this.getTrackerName();
            if (trackerName !== null) {
                tracker = ga.getByName(trackerName);
            }
            _this.trackerOriginalSendHitTask = tracker.get("sendHitTask");
            tracker.set("sendHitTask", _this.sendHitTask.bind(_this)); // GA messes with the `this` so binding was needed.
        });
        // Record that hit interceptor is setup (technically it may not be since the ga() callback above is aysnc, but close enough since we don't want to setup multiple instances.
        this.isHitInterceptorSetup = true;
    };
    /**
     * @private
     * Our own implementation of "sendHitTask" which setupHitInterceptor() sets up
     * to intercept hits.
     */
    GoogleAnalytics.prototype.sendHitTask = function (model) {
        // Mirror stray hit (if there are are any registered and if this is a stray hit)
        if (this.trackersToMirrorStrayHits !== undefined) {
            // Check if it is not a stray event
            var hitOrigin = model.get("plaudit_hitOrigin");
            if (hitOrigin === undefined) {
                var hitType = model.get("hitType");
                if (hitType === "pageview") {
                    this.trackersToMirrorStrayHits.pageviews.forEach(function (tracker) {
                        tracker.trackPageview(model.get("page"), model.get("title"));
                    });
                }
                else if (hitType === "event") {
                    this.trackersToMirrorStrayHits.events.forEach(function (tracker) {
                        tracker.trackEvent(model.get("eventCategory"), model.get("eventAction"), model.get("eventLabel"), model.get("eventValue"), model.get("nonInteraction"));
                    });
                }
            }
        }
        // Notify observers
        this.notifyHitObservers(model);
        // Send event to GA using the original hitTask
        if (this.trackerOriginalSendHitTask !== undefined && this.trackerOriginalSendHitTask !== null) {
            this.trackerOriginalSendHitTask(model);
        }
    };
    /**
     * The observer will be notified of stray hits as well (i.e. the hits which were sent directly to GA and not through this class).
     */
    GoogleAnalytics.prototype.addHitObserver = function (observer) {
        if (this.observers === undefined) {
            this.observers = new Set();
        }
        this.observers.add(observer);
    };
    GoogleAnalytics.prototype.removeHitObserver = function (observer) {
        if (this.observers === undefined) {
            return;
        }
        this.observers.delete(observer);
    };
    GoogleAnalytics.prototype.notifyHitObservers = function (model) {
        var _this = this;
        if (this.observers === undefined) {
            return;
        }
        this.observers.forEach(function (observer) {
            observer.update(_this, model);
        });
    };
    GoogleAnalytics.platformName = "GoogleAnalytics";
    GoogleAnalytics.defaultOptions = {
        globalKeyForPlatform: "ga"
    };
    return GoogleAnalytics;
}(BasicTrackerAbstractImpl_1.default));
exports.default = GoogleAnalytics;
